import { routes } from "@constants/routes";
import {
  IndustryForm,
  useGetProfileIndustryQuery,
  useGetWorkExperienceByIdLazyQuery,
  useGetWorkExperiencesQuery,
  useResumeStore,
  UserTypeEnum,
  WorkExperienceForm,
  WorkExperienceTable,
} from "@cpj-ai/panel-npm-package";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
export type WorkState = "TABLE" | "FORM";

interface IWorkExperienceTabContent {
  handleNextTab: () => void;
}

const WorkExperienceTabContent = ({ handleNextTab }: IWorkExperienceTabContent) => {
  const [workState, setWorkState] = useState<WorkState>("TABLE");
  const { setWorkExperienceEditId } = useResumeStore();
  const { data, refetch, loading } = useGetWorkExperiencesQuery();
  const { data: profileIndustry, loading: loadingGetProfileIndustry } = useGetProfileIndustryQuery();
  const [getWorkExperienceInfoById, { data: workExperienceInfoByIdData, loading: workExperienceInfoByIdLoading }] =
    useGetWorkExperienceByIdLazyQuery();

  useEffect(() => {
    setWorkExperienceEditId(undefined);
  }, [setWorkExperienceEditId]);

  const location = useLocation();

  return (
    <div>
      {workState === "TABLE" ? (
        <>
          <IndustryForm
            industry={profileIndustry?.me?.profile?.industry}
            loadingGetProfileIndustry={loadingGetProfileIndustry}
          />
          <WorkExperienceTable
            setWorkState={setWorkState}
            workState={workState}
            handleNextTab={handleNextTab}
            data={data?.me?.workexperiences || []}
            refetch={refetch}
            loading={loading}
            showAddNewSection={true}
          />
        </>
      ) : (
        <WorkExperienceForm
          setWorkExperienceState={setWorkState}
          supportUrl={routes.support.main}
          pathname={location.pathname}
          getExperienceInfoById={getWorkExperienceInfoById}
          experienceInfo={workExperienceInfoByIdData?.workExperience?.get}
          getExperienceInfoLoading={workExperienceInfoByIdLoading}
          userType={UserTypeEnum.USER}
        />
      )}
    </div>
  );
};

export default WorkExperienceTabContent;
